// extracted by mini-css-extract-plugin
module.exports = {"Brand":"Brand_Brand__1Smc1"};